<template>
  <div>
    <!-- Navbar Start -->
    <nav id='skylarknav' class="navbar navbar-expand-sm sd-bg--white sd-nav">
      <router-link
        :to="{ name : 'Dashboard'}"
        tag="a" class="navbar-brand"
      >
        <img src="@/assets/img/logo_icon.svg" width="25px"  alt="">
      </router-link>
      <!-- <a class="navbar-brand" href="#">
        <img src="@/assets/img/logo_icon.svg" width="25px"  alt="">
      </a> -->
      <!-- TODO: Remove toggler if not using bootstraps JS file -->
      <button
        class="navbar-toggler"
        type="button"
        data-toggle="collapse"
        data-target="#navbarSupportedContent"
        aria-controls="navbarSupportedContent"
        aria-expanded="false"
        aria-label="Toggle navigation">
        <span class="navbar-toggler-icon"></span>
      </button>

      <div class="collapse navbar-collapse" id="navbarSupportedContent">
         <!-- <div class="sd-vertical-line"></div> -->
        <ul class="navbar-nav mr-auto d-flex align-items-center">
          <div class="sd-vertical-line pr-3"></div>
          <li class="nav-item">
            <p class="sd-nav-text p-0 m-0 text-muted">Projects</p>
            <a class="sd-nav-link nav-link p-0">{{currentProject.name}}</a>
          </li>
          <div class="sd-vertical-line ml-3 pr-3"></div>
          <li class="nav-item">
            <p class="sd-nav-text p-0 m-0 text-muted">Phase</p>
            <div class="dropdown">
               <a
                class="dropdown-toggle"
                @click="showDropdown =! showDropdown"
                v-click-outside="hideDropdown">
               {{subsection.name}}
               </a>
               <div class="dropdown-menu" :class="{'dropdown-box':showDropdown}">
                 <a v-for="data of sub_names" :key="data.sub_id" class="dropdown-item" @click="OpenVideoMode(project_id, data.sub_id)">{{data.sub_names}}<br></a>
              </div>
            </div>
          </li>
          <!-- <div class="sd-vertical-line ml-3 pr-3" v-if='currentProject.subsections.length>1'></div>
          <div class="d-flex flex-row  px-2 py-1" v-if='currentProject.subsections.length>1'>
            <div class="sd-font-small">
               TODO: This should probably be a different icon. Do you have anything that can be used
              View All Phases
            </div>
            <div>
              <label class="sd-toggle">
                <input type="checkbox" :checked="isAllProjectDataVisible" @click.stop="projectVisibilityClickHandler" >
                <span class="sd-toggle-slider round"></span>
              </label>
            </div>
          </div> -->
          <div class="sd-vertical-line ml-3 pr-3" v-if="isChainageEnabled"></div>
          <li class="nav-item" v-if="isChainageEnabled && chainageValue">
            <a class="sd-nav-phase-status nav-link p-2 pr-0 sd-bg--gray">
              Current Chainage:  {{ chainageValue }}
            <span v-show="0" class="invisible">
              {{chainageValue}}
            </span>
            </a>
          </li>
          <div  v-if="isChainageEnabled && chainageValue" class="sd-vertical-line ml-3 pr-3"></div>
          <li class="nav-item" v-if="isChainageEnabled">
            <input
              type="text"
              class="form-control form-control-sm"
              v-on:keypress.enter="updatePosDataFromNav"
              :placeholder="getChainageRange"
              :title="getChainageRange"
              style="font-size:0.8rem;"
            >
          </li>
          <li v-if="errorMsg">
            <p class="sd-nav-text text-primary pl-2">{{errorMsg}}</p>
          </li>
        </ul>
      </div>
      <div>
        <button-spinner style='padding-right: 20px' class="sd-spinner d-inline" v-if="reportGenInProgress"></button-spinner>
        <a
          class="btn btn-outline-primary sd-font-xs text-uppercase mr-4 sd-report-btn d-inline"
          @click="generateReport"
          v-if="!reportGenInProgress">
          Generate Report
        </a>
      </div>
       <div class="sd-iconalign1">
        <profileIcon></profileIcon>
      </div>
    </nav>
    <!-- Navbar End -->
  </div>
</template>


<script>
import L from 'leaflet';
import api from '@/api';
import * as vClickOutside from 'v-click-outside-x';
import { mapMutations, mapState } from 'vuex';
import { getClosestIndexFromChainage, getClosestIndexFromLatLng } from '@/utils/posDataOperations';
import { POSITION_TIME_DATA_SETTERS } from '@/config';
import  profileIcon from '@/components/profileIcon.vue';
import spinner from '@/components/spinner.vue';
import { API_ROOT } from '@/config';

export default {
  props: ['pid','sid'],
  data() {
    return {
      staticReport: false,
      reportURL: '',
      showDropdown:false,
      reportGenInProgress:false,
      chainageValue: 0,
      isChainageEnabled: false,
      errorMsg: '',
      subsection: '',
      sub_names: [],
    };
  },
  directives: {
    clickOutside: vClickOutside.directive
  },
  components: {
    profileIcon,
    'button-spinner':spinner,
  },
  mounted() {
    this.initProject();
  },
  computed: {
    ...mapState([
      'currentProject',
      'globalPosData',
      'positionTimeData',
      'isAllProjectDataVisible',
    ]),
    getChainageRange: function () {
      if (this.positionTimeData.length) {
        return 'Enter Chainage (' + this.positionTimeData[0].chainage + ' - ' + this.positionTimeData[this.positionTimeData.length - 1].chainage + ')';
      }
    },
  },
  watch: {
    currentProject() {
      this.initProject();

      Array.from(this.currentProject.project_features).forEach((feat) => {
        if (feat.feature_name == 'staticReport' && feat.enabled) {
          this.staticReport = true;
          this.reportURL = this.currentProject.report;
        } else if ( feat.feature_name == 'chainageProject' && feat.enabled ) {
          this.isChainageEnabled = true;
        }
      });
    },
    globalPosData() {
      const latlng = L.latLng(
        this.globalPosData.lat,
        this.globalPosData.lng,
      );
      const closestIndex = getClosestIndexFromLatLng(latlng, this.positionTimeData, L);
      this.chainageValue = this.positionTimeData[closestIndex].chainage || 0;
    },
    sid() {
      this.initProject();
    }
  },
  methods: {
    ...mapMutations([
      'setGlobalPosData',
      'setCurrentSid',
      'toggleAllProjectVisibility',
    ]),
    generateReport() {
      if(this.staticReport) {
        let link = document.createElement("a");
        link.setAttribute("download", 'Enzen');
        link.target = '_blank';
        link.download = 'Enzen';
        link.href = this.reportURL;
        link.click();
      } else {
        api.downloadReport(this.pid)
            .then((response) => {
              if (response.status === 200) {
                this.reportGenInProgress = true;
                this.pollReportGen(response.data.download_id);
                // this.pollVExport('d24076eb-f4a3-4db0-8fcc-80ede8c77b2c');
              } else {
                // console.log('error', response);
                // TODO: Handle Error
              }
        });
      }
    },
    // TODO: Donot Allow Refresh
    // TODO: Add Timeout
    pollReportGen(download_id) {
      api.pollExport(download_id)
        .then((res) => {
          if (res.status === 201) {
            window.location.href = `${API_ROOT}api/download_pdf/?download_id=${download_id}`;
            this.reportGenInProgress = false;
          } else if (res.status === 202) {
            setTimeout(this.pollReportGen, 3000, download_id);
          }
        })
        .catch(() => {
          // console.log(err);
          // TODO: Handle error
          return false;
        });
    },
    initProject() {
      this.project_id = this.currentProject.project_id;
      this.getSubsectionData();
      this.getSubsectionNames();
    },
    updatePosDataFromNav(event) {
      let closestIndex = 0;
      const lastIndex = this.positionTimeData.length - 1;
      let chainageValue = 0;
      let posData = {
        lat: 0,
        lng: 0,
        setter: '',
      };

      // TODO: Fix This work around and remove global chainageValue assignment.
      this.chainageValue = event.target.value;
      if (isNaN(parseFloat(event.target.value))) {
        this.errorMsg = 'Enter Valid Number';
      } else {
        this.errorMsg = '';
        chainageValue = parseFloat(event.target.value);

        this.$root.$emit('pausevideo');
        // Handle Error Cases before parsing through pos data file
        if (chainageValue < this.positionTimeData[0].chainage) {
          // Entered Chainage is less than Minimum Chainage, So set closest index as 0
          closestIndex = 0;
          this.errorMsg = 'Chainage out of range. Playing from Start';
        } else if (chainageValue > this.positionTimeData[lastIndex].chainage) {
          // Entered Chainage is more than Maximum Chainage, So set closest index to be last index
          closestIndex = lastIndex;
          this.errorMsg = 'Chainage out of range. Enter between ' + this.positionTimeData[0].chainage + ' and ' + this.positionTimeData[lastIndex].chainage;
        } else {
          closestIndex = getClosestIndexFromChainage(chainageValue, this.positionTimeData);
        }

        if (closestIndex !== -1) {
          posData.lat = this.positionTimeData[closestIndex].lat;
          posData.lng = this.positionTimeData[closestIndex].lng;
          posData.setter = POSITION_TIME_DATA_SETTERS.NAVBAR;
          this.setGlobalPosData(posData);
        } else {
          // Handle error for -1
          // console.log('error');
        }
        this.$root.$emit('playvideo');
      }
    },

    getSubsectionData() {
      // TODO: Save this in store as currentSubsection as well.
      if (!this.currentProject.subsections) { return; }
      Array.from(this.currentProject.subsections).forEach((subsection) => {
        if (subsection.subsection_id === parseInt(this.sid, 10)) {
          // TODO: update function name or remove next line
          this.subsection = subsection;
        }
      });
    },

    getSubsectionNames() {
      if (!this.currentProject.subsections) { return; }
      this.sub_names = [];
      Array.from(this.currentProject.subsections).forEach((subsection) => {
        this.sub_names.push({"sub_id":subsection.subsection_id,"sub_names":subsection.name});
      });
    },

    OpenVideoMode(projectId, subsectionId) {
      this.setCurrentSid(subsectionId);
    },
    projectVisibilityClickHandler() {
      this.toggleAllProjectVisibility(!this.isAllProjectDataVisible);
    },

    hideDropdown() {
      this.showDropdown = false;
    }
  },
};
</script>


<style lang="scss">
@import '@/assets/sass/_variables.scss';

.sd-nav{
 z-index: 3;
 box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.5);
}

.sd-nav-text {
  font-size: 0.8rem;
}

.sd-nav-link {
  font-size: 0.9rem;
  color: $gray-dark !important;
  &:hover{
    color: $gray-dark !important;
  }
}

.sd-vertical-line {
  // TODO: Donot use direct color codes. Ask designer to update color palatte
  border-left: 2px solid #d8d8d8;
  height: 20px;
  width: 2px;
}

.sd-nav-phase-status {
  font-size: .8rem;
  border-radius: .2rem;
  // TODO: Donot use direct color codes. Ask designer to update color palatte
  border: 1px solid #eaeaea;
  color: $gray-dark !important;
  &:hover{
    color: $gray-dark !important;
  }
}

.sd-iconalign1{
  display:absolute;
  top:16px;
  left:83%;
}

.sd-report-btn {
  color: $primary !important;
  &:hover {
    color: $white !important;
  }
}

</style>
